function initialiseCardReveals() {
  const cards = document.querySelectorAll(".elearning-card");
  const prefersHover = window.matchMedia("(hover: hover)").matches;

  cards.forEach((card) => {
    const reveal = card.querySelector(".card-reveal");
    if (!reveal) return;

    const trigger = card.querySelector(".card-reveal-toggle");
    if (!trigger) return;

    const front = card.querySelector(".card-front");
    const back = card.querySelector(".card-back");

    const backId = `card-back-${Math.random().toString(36).slice(2, 7)}`;
    back.id = backId;

    if (trigger.tagName !== "BUTTON") {
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");
    }

    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-controls", backId);

    const headingText = front.querySelector(".card-title")?.textContent?.trim();
    if (headingText) {
      trigger.setAttribute("aria-label", `Show more about: ${headingText}`);
    }

    back.setAttribute("aria-hidden", "true");

    const setExpanded = (expanded) => {
      reveal.classList.toggle("active", expanded);
      trigger.setAttribute("aria-expanded", String(expanded));
      back.setAttribute("aria-hidden", String(!expanded));
    };

    const toggle = () => {
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      setExpanded(!isExpanded);
    };

    trigger.addEventListener("click", toggle);

    if (trigger.tagName !== "BUTTON") {
      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    }

    if (prefersHover) {
      card.addEventListener("mouseenter", () => setExpanded(true));
      card.addEventListener("mouseleave", () => setExpanded(false));
    }
  });
}

document.addEventListener("DOMContentLoaded", initialiseCardReveals);
